import { CT } from "../../../consts";

const allTemplates = [
  CT.eventList,
  CT.weekly,
  CT.cardList,
  CT.card,
  CT.cardSlider,
  CT.monthly,
  CT.detailedList,
  CT.bubble,
];
const showConditionsEvent = [
  {
    field: "eventDetailsShowSubscribeOptions",
    value: 1,
    defaultValue: 1,
  },
];

const showConditionsCalendar = [
  {
    field: "calendarShowSubscribe",
    value: 1,
    defaultValue: 0,
  },
];

const showConditionsCalendarOrEvent = [
  ...showConditionsEvent,
  ...showConditionsCalendar
  // {
  //   field: "calendarShowSubscribe",
  //   value: 1,
  //   defaultValue: 0,
  //   or: true,
  // },
];

showConditionsCalendarOrEvent[1].or = true;

const showConditionsShareDesignOptions = [
  ...showConditionsCalendarOrEvent,
  {
    field: "popupSubscribeShow",
    value: 1,
    defaultValue: 1,
  },
  {
    field: "popupRSSLink",
    value: 1,
    defaultValue: 1,
    or: true,
  },
];
const showConditionsShareHighlightsOptions = [
  ...showConditionsCalendarOrEvent,
  {
    field: "popupRSSLink",
    value: 1,
    defaultValue: 1,
  },
];

const individualDesignOptions = [
  {
    title: "Icon border color",
    templates: allTemplates,
    name: "popupSubscribeIconBorderColor",
    applicable: "design",
    defaultValue: "#e0e0e0",
    style: {
      selector:
        ".dc-subscribe-popup--add-to-calendar-container .dc-subscribe-popup--add-to-calendar-link img",
      property: "border-color",
    },
    tooltip: null,
    control: {
      kind: "color",
    },
    show: showConditionsShareDesignOptions,
  },
  {
    title: "Icon border color hover",
    templates: allTemplates,
    name: "popupSubscribeIconBorderColorHover",
    applicable: "design",
    defaultValue: "#e0e0e0",
    style: {
      selector:
        ".dc-subscribe-popup--add-to-calendar-container .dc-subscribe-popup--add-to-calendar-link:hover img",
      property: "border-color",
    },
    tooltip: null,
    control: {
      kind: "color",
    },
    show: showConditionsShareDesignOptions,
  },
  {
    title: "Icon background color",
    templates: allTemplates,
    name: "popupSubscribeIconBg",
    applicable: "design",
    defaultValue: "#fff",
    style: {
      selector:
        ".dc-subscribe-popup--add-to-calendar-container .dc-subscribe-popup--add-to-calendar-link img",
      property: "background-color",
    },
    tooltip: null,
    control: {
      kind: "color",
    },
    show: showConditionsShareDesignOptions,
  },
  {
    title: "Icon background hover",
    templates: allTemplates,
    name: "popupSubscribeIconBgHover",
    applicable: "design",
    defaultValue: "#fff",
    style: {
      selector:
        ".dc-subscribe-popup--add-to-calendar-container .dc-subscribe-popup--add-to-calendar-link:hover img",
      property: "background-color",
    },
    tooltip: null,
    control: {
      kind: "color",
    },
    show: showConditionsShareDesignOptions,
  },
  {
    title: "Label color",
    templates: allTemplates,
    name: "popupSubscribeColor",
    applicable: "design",
    defaultValue: "#0c0c0c",
    style: {
      selector:
        ".dc-subscribe-popup--add-to-calendar-container .dc-subscribe-popup--add-to-calendar-link",
      property: "color",
    },
    tooltip: null,
    control: {
      kind: "color",
    },
    show: showConditionsShareDesignOptions,
  },
  {
    title: "Label color hover",
    templates: allTemplates,
    name: "popupSubscribeColorHover",
    applicable: "design",
    defaultValue: "#0C0C0CCE",
    style: {
      selector:
        ".dc-subscribe-popup--add-to-calendar-container .dc-subscribe-popup--add-to-calendar-link:hover",
      property: "color",
    },
    tooltip: null,
    control: {
      kind: "color",
    },
    show: showConditionsShareDesignOptions,
  },
  {
    title: "RSS Icon color",
    templates: allTemplates,
    name: "popupRSSIconColor",
    applicable: "design",
    defaultValue: "#F08305",
    style: {
      selector: ".dc-subscribe-popup--rss-feed-link i",
      property: "color",
    },
    tooltip: null,
    control: {
      kind: "color",
    },
    show: [
      ...showConditionsCalendarOrEvent,
      {
        field: "popupRSSLink",
        value: 1,
        defaultValue: 1,
      },
    ],
  },
  {
    title: "RSS Icon color hover",
    templates: allTemplates,
    name: "popupRSSIconColorHover",
    applicable: "design",
    defaultValue: "#F08305",
    style: {
      selector: ".dc-subscribe-popup--rss-feed-link:hover i",
      property: "color",
    },
    tooltip: null,
    control: {
      kind: "color",
    },
    show: [
      ...showConditionsCalendarOrEvent,
      {
        field: "popupRSSLink",
        value: 1,
        defaultValue: 1,
      },
    ],
  },
];

const individualDesignOptionsForHighlights = [...individualDesignOptions].map(
  (i) => ({
    ...i,
    applicable: "highlights",
    show: showConditionsShareHighlightsOptions,
  })
);

export const definitions = {
  title: "Add to Calendar",
  icon: "add",
  groups: [
    {
      label: "Add to calendar",
      options: [
        {
          title: "Show Add to cal. button",
          templates: [
            CT.eventList,
            CT.weekly,
            CT.cardList,
            CT.card,
            CT.cardSlider,
            CT.monthly,
            CT.detailedList,
          ],
          applicable: "design",
          name: "calendarShowSubscribe",
          defaultValue: 0,
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },

        {
          title: "Add to cal. button",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
          ],
          name: "calendarSubscribe",
          defaultValue: {
            bg: "#fff",
            bgHover: "#D3D3D3",
            borderRadius: "10px",
            padding: "0em 0.6em 0em 0.6em",
            borderColor: "#D3D3D3",
            borderColorHover: "#D3D3D3",
            borderWidth: "2px",
          },
          style: {
            selector: [".dc-calendar-subscribe-button"],
          },
          show: showConditionsCalendar,
          control: {
            kind: "surface",
            options: {
              showBg: true,
              showBgHover: true,
              showPadding: true,
              showMargin: true,
              showBorderStyle: true,
              showBorderWidth: true,
              showBorderColor: true,
              showBorderColorHover: true,
              showBorderRadius: true,
            },
          },
        },

        {
          title: "Add to cal. button label",
          templates: [
            CT.eventList,
            CT.monthly,
            CT.weekly,
            CT.card,
            CT.cardList,
            CT.cardSlider,
          ],
          name: "calendarSubscribeTypography",
          defaultValue: {
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "1em",
            color: "#333",
            colorHover: "#333",
          },
          style: {
            selector: [".dc-calendar-subscribe-button"],
          },
          show: showConditionsCalendar,
          control: {
            kind: "typography",
            options: {
              showFontSize: true,
              showFontWeight: true,
              showColor: true,
              showColorHover: true,
              showLineHeight: true,
            },
          },
        },
        {
          title: "Add to cal. button",
          templates: [CT.detailedList],
          name: "calendarSubscribe",
          defaultValue: {
            bg: "#fff",
            bgHover: "#edf2f7",
            borderRadius: "18px",
            padding: "0.6em 1em 0.6em 1em",
            borderColor: "#fff",
            borderColorHover: "#fff",
            borderWidth: "0.5px",
          },
          style: {
            selector: [".dc-detailed-list--calendar-subscribe-button"],
          },
          show: showConditionsCalendar,
          control: {
            kind: "surface",
            options: {
              showBg: true,
              showBgHover: true,
              showPadding: true,
              showMargin: true,
              showBorderStyle: true,
              showBorderWidth: true,
              showBorderColor: true,
              showBorderColorHover: true,
              showBorderRadius: true,
            },
          },
        },

        {
          title: "Add to cal. button label",
          templates: [CT.detailedList],
          name: "calendarSubscribeTypography",
          defaultValue: {
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "1em",
            color: "#2d3748",
            colorHover: "#2d3748",
          },
          style: {
            selector: [".dc-detailed-list--calendar-subscribe-button"],
          },
          show: showConditionsCalendar,
          control: {
            kind: "typography",
            options: {
              showFontSize: true,
              showFontWeight: true,
              showColor: true,
              showColorHover: true,
              showLineHeight: true,
            },
          },
        },
      ],
    },
    {
      label: "Individual event subscription",
      options: [
        {
          title: "Show Add to cal. button in event details",
          templates: allTemplates,
          name: "eventDetailsShowSubscribeOptions",
          defaultValue: 1,
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },

        {
          title: "Add to cal. Button",
          templates: allTemplates,
          name: "eventDetailsAddToCal",
          defaultValue: {
            bg: "#00aafb",
            bgHover: "#00AAFBB3",
            borderRadius: "25px",
            padding: "0.3em 1.4em 0.3em 1.4em",
          },
          style: {
            selector: [
              ".event-row--details .dc-event-add-to-calendar.dc-event-add-to-calendar--link",
            ],
          },
          show: showConditionsEvent,
          control: {
            kind: "surface",
            options: {
              showBg: true,
              showBgHover: true,
              showPadding: true,
              showMargin: true,
              showBorderStyle: true,
              showBorderWidth: true,
              showBorderColor: true,
              showBorderRadius: true,
            },
          },
        },

        {
          title: "Add to cal. button label",
          templates: allTemplates,
          name: "eventDetailsAddToCalTypography",
          defaultValue: {
            fontSize: "1em",
            fontWeight: "500",
            color: "#fff",
            colorHover: "#fff",
            textTransform: "uppercase",
          },
          style: {
            selector: [
              ".event-row--details .dc-event-add-to-calendar.dc-event-add-to-calendar--link",
            ],
          },
          show: showConditionsEvent,
          control: {
            kind: "typography",
            options: {
              showFontSize: true,
              showFontWeight: true,
              showColor: true,
              showColorHover: true,
              showTextTransform: true,
            },
          },
        },
      ],
    },
    {
      label: "Popup design",
      // message: "Apply to both calendar & individual events.",
      options: [
        {
          title: "Background color",
          templates: allTemplates,
          name: "subscribePopupBgColor",
          defaultValue: "#fff",
          show: showConditionsCalendarOrEvent,
          style: {
            selector: ".dc-subscribe-popup--card",
            property: "background-color",
          },
          tooltip: null,
          control: {
            kind: "color",
          },
        },
        {
          title: "Card title color",
          templates: allTemplates,
          name: "subscribePopupTitleColor",
          defaultValue: "#000",
          show: showConditionsCalendarOrEvent,
          style: {
            selector: [".dc-subscribe-popup--card-section--header"],
            property: "color",
          },
          tooltip: null,
          control: {
            kind: "color",
          },
        },
        {
          title: "Section label color",
          templates: allTemplates,
          name: "subscribePopupSourceColor",
          defaultValue: "#000",
          show: showConditionsCalendarOrEvent,
          style: {
            selector: ".dc-subscribe-popup--card-section--subheader",
            property: "color",
          },
          tooltip: null,
          control: {
            kind: "color",
          },
        },
        {
          title: "Separator color",
          templates: allTemplates,
          name: "subscribePopupSeparatorColor",
          defaultValue: "#e0e0e0",
          show: showConditionsCalendarOrEvent,
          style: {
            selector: [
              ".dc-subscribe-popup--rss-feed-container",
              ".dc-subscribe-popup--card-section--subheader",
            ],
            property: "border-color",
          },
          tooltip: null,
          control: {
            kind: "color",
          },
        },
        {
          title: "Close button color",
          templates: allTemplates,
          name: "subscribePopupCloseButtonColor",
          defaultValue: "#333",
          show: showConditionsCalendarOrEvent,
          style: {
            selector: [
              ".dc-subscribe-popup--card--close::before",
              ".dc-subscribe-popup--card--close::after",
            ],
            property: "background-color",
          },
          tooltip: null,
          control: {
            kind: "color",
          },
        },
        {
          title: "Close button color on hover",
          templates: allTemplates,
          name: "subscribePopupCloseButtonColorOnHover",
          defaultValue: "#333",
          show: showConditionsCalendarOrEvent,
          style: {
            selector: [
              ".dc-subscribe-popup--card--close:hover::before",
              ".dc-subscribe-popup--card--close:hover::after",
            ],
            property: "background-color",
          },
          tooltip: null,
          control: {
            kind: "color",
          },
        },
        {
          title: "Show Add to cal. options",
          templates: allTemplates,
          name: "popupSubscribeShow",
          applicable: "design",
          defaultValue: 1,
          show: showConditionsCalendarOrEvent,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show RSS link",
          templates: allTemplates,
          name: "popupRSSLink",
          defaultValue: 1,
          show: showConditionsCalendarOrEvent,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        ...individualDesignOptions,
        ...individualDesignOptionsForHighlights,
      ],
    },
  ],
};
